module.exports = __webpack_public_path__ + "static/media/pages.cdff9ecf.svg";